import React from "react";

interface CardProps {
  mainClass?: string;
  title?: string | any;
  titleClass?: string;
  icon?: any;
  children?: any;
}

const CustomCard = ({
  mainClass,
  title,
  titleClass,
  icon,
  children,
}: CardProps) => {
  return (
    <div
      className={`rounded-xl p-4 w-full flex flex-col items-start gap-2 ${mainClass}`}
    >
      <div className={"flex items-center justify-between w-full"}>
        <div className={`text-sm font-bold ${titleClass}`}> {title}</div>
        {icon}
      </div>
      {children}
    </div>
  );
};

export default CustomCard;
